const _i18n_info = {
  token_expire: {
    EN: `Auth token expire later 3 min`,
    KO: `인증실패 3분후에 다시 시도하세요`,
    JP: `認証トークンは3分後に期限切れになります`,
  },
  authorize_sucess : {
    EN: `Authorize successfully`,
    KO: `인증 성공.`,
    JP: `正常に承認されました`
  }
}

const _i18n_warning = {
  otpVerify : {
    EN: `expired, not allowed, try request auth email again`,
    KO: `허용되지 않습니다. 인증 이메일을 다시 요청하세요..`,
    JP: `有効期限が切れています。許可されていません。認証メールをもう一度リクエストしてください`
  },
  newPassword: {
    EN: `Typing new password`,
    KO: `새로운 패스워드를 입력하세요.`,
    JP: `新しいパスワードを入力します`
  },
  newPassword_2: {
    EN: `Typing new password repeat`,
    KO: `새로운 패스워드확인을 입력하세요..`,
    JP: `新しいパスワードを繰り返し入力します`
  },
  newPassword_3: {
    EN: `not same password and password repeat`,
    KO: `새로운 암호가 다릅니다..`,
    JP: `同じパスワードではありません。繰り返し入力してください`
  }
}

const _i18n_error = {
  otpToken: {
    EN: `reset failed`,
    KO: `초기화 실패.`,
    JP: `パスワードリセットに失敗しました`,
  },
}

const _i18n_alert = {
  newPassword_change: {
    EN: `changed successfully`,
    KO: `비밀번호 변경 성공.`,
    JP: `正常に変更されました`,
  }
}

const i18n_toastr = {
  _i18n_info,
  _i18n_warning,
  _i18n_error,
  _i18n_alert
}

export default i18n_toastr